import { pgTable, uuid, text, boolean, jsonb, timestamp } from "drizzle-orm/pg-core";

// Singleton toggle + non-secret config for the Moneo ERP integration.
// Secrets (MONEO_API_KEY / MONEO_COMPANY_ID) live in env vars, never here.
export const moneoSettings = pgTable("moneo_settings", {
  id: uuid("id").primaryKey().defaultRandom(),
  active: boolean("active").notNull().default(false),
  displayName: text("display_name").notNull().default("Moneo ERP"),
  config: jsonb("config").notNull().default({}),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
});

export type MoneoSetting = typeof moneoSettings.$inferSelect;
export type NewMoneoSetting = typeof moneoSettings.$inferInsert;
